/** Random bytes, identifiers and connect codes, from the browser's CSPRNG, shared by the in-memory and demo backends. */
import { CONNECT_CODE_ALPHABET, CONNECT_CODE_LENGTH, ID_ALPHABET } from './labels';

export function randomBytes(length: number): Uint8Array<ArrayBuffer> {
  const bytes = new Uint8Array(new ArrayBuffer(length));
  globalThis.crypto.getRandomValues(bytes);
  return bytes;
}

/** A random id of `length` URL-safe characters. */
export function randomId(length = 22): string {
  return Array.from(randomBytes(length), (b) => ID_ALPHABET[b % ID_ALPHABET.length] ?? 'A').join('');
}

/** A six-letter connect code; 24 letters divide 240, so bytes below 240 give an unbiased draw. */
export function randomConnectCode(): string {
  let code = '';
  while (code.length < CONNECT_CODE_LENGTH) {
    for (const draw of randomBytes(12)) {
      if (draw < 240 && code.length < CONNECT_CODE_LENGTH) code += CONNECT_CODE_ALPHABET[draw % CONNECT_CODE_ALPHABET.length] ?? 'A';
    }
  }
  return code;
}

const CONNECT_CODE_SHAPE = new RegExp(`^[${CONNECT_CODE_ALPHABET}]{${String(CONNECT_CODE_LENGTH)}}$`);

/** True for six letters of the code's own alphabet (what `randomConnectCode` makes, with the dash and case stripped). */
export function isConnectCode(code: string): boolean {
  return CONNECT_CODE_SHAPE.test(code);
}
